import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { PublicPageFrame } from "../components/layout/PublicPageFrame";

const cardClass =
  "bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl p-8 w-full max-w-md";

export function RecuperarPasswordPage() {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api.post("/auth/recuperar-password", { email: email.trim().toLowerCase() });
      setSuccess(true);
    } catch {
      setError("No se pudo enviar el enlace. Inténtalo de nuevo más tarde.");
    } finally {
      setSubmitting(false);
    }
  };

  if (success) {
    return (
      <PublicPageFrame>
        <div className={`${cardClass} text-center`}>
          <h1 className="text-xl font-semibold text-[#2C2C2C]">Revisa tu correo</h1>
          <p className="mt-4 text-gray-600">
            Si el email está registrado recibirás un enlace en breve. Revisa también tu carpeta de spam.
          </p>
          <Link
            to="/login"
            className="mt-6 inline-block text-sm font-medium text-[#1A3AB8] hover:underline"
          >
            Volver al inicio de sesión
          </Link>
        </div>
      </PublicPageFrame>
    );
  }

  return (
    <PublicPageFrame>
      <div className={cardClass}>
        <h1 className="mb-6 text-xl font-semibold text-[#2C2C2C]">Recuperar contraseña</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="mb-1 block text-sm font-medium text-[#2C2C2C]">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-[#2C2C2C] focus:border-[#1A3AB8] focus:outline-none focus:ring-1 focus:ring-[#1A3AB8]"
              placeholder="tu@email.com"
            />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-lg bg-[#1A3AB8] px-4 py-2.5 font-medium text-white transition hover:bg-[#15308a] disabled:opacity-50"
          >
            {submitting ? "Enviando…" : "Enviar enlace de recuperación"}
          </button>
        </form>
        <p className="mt-4 text-center text-sm text-gray-600">
          <Link to="/login" className="font-medium text-[#1A3AB8] hover:underline">
            Volver al inicio de sesión
          </Link>
        </p>
      </div>
    </PublicPageFrame>
  );
}
